import React, { useState, useRef, useEffect } from 'react';

import HeroSection from '../components/LandingSections/HeroSection';
import CuriositySection from '../components/LandingSections/CuriositySection';
import ConnectSection from '../components/LandingSections/ConnectSection';

import Navigation from '../components/Navigation/Navigation';

const JaliSection = React.lazy(() => import('../components/LandingSections/JaliSection'));

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [showScrollHint, setShowScrollHint] = useState(true);
  const isAnimating = useRef(false);
  const activeSectionRef = useRef(0);

  const scrollProgress = (activeSectionRef.current / 3) * 100;

  const goForward = () => {
    if (isAnimating.current || activeSectionRef.current >= 3) return;
    isAnimating.current = true;
    activeSectionRef.current += 1;
    setActiveSection(activeSectionRef.current);
    setShowScrollHint(false);
    setTimeout(() => { isAnimating.current = false; }, 1400);
  };

  const goBack = () => {
    if (isAnimating.current || activeSectionRef.current <= 0) return;
    isAnimating.current = true;
    activeSectionRef.current -= 1;
    setActiveSection(activeSectionRef.current);
    setTimeout(() => { isAnimating.current = false; }, 1400);
  };

  useEffect(() => {
    const img = new Image();
    img.src = 'https://dev.daatglobal.com/email-assets/arch-biggest.gif';
  }, []);

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.deltaY > 0) goForward();
      else goBack();
    };

    let touchStartY = 0;
    const handleTouchStart = (e) => { touchStartY = e.touches[0].clientY; };
    const handleTouchEnd = (e) => {
      const diff = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diff) < 50) return;
      if (diff > 0) goForward();
      else goBack();
    };

    window.addEventListener('wheel', handleWheel, { passive: true });
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchend', handleTouchEnd, { passive: true });
    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  const sections = [
    { Component: HeroSection, zIndex: 10 },
    { Component: CuriositySection, zIndex: 20 },
    { Component: ConnectSection, zIndex: 30 },
    { Component: () => (
      <React.Suspense fallback={<div className="h-screen w-full bg-black" />}>
        <JaliSection />
      </React.Suspense>
    ), zIndex: 40 },
  ];

  return (
    <div style={{ position: 'fixed', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <div className="fixed top-0 left-0 w-full z-50 pointer-events-none">
        <div className="pointer-events-auto">
          <Navigation />
        </div>
      </div>

      <div className="fixed right-8 top-1/2 -translate-y-1/2 z-50 flex flex-col items-center gap-2">
        <div className="w-px h-32 bg-white/20 relative overflow-hidden">
          <div
            className="absolute top-0 left-0 w-full bg-[#A47F2D] transition-all duration-300"
            style={{ height: `${scrollProgress}%` }}
          />
        </div>

        <div className="flex flex-col gap-3 absolute top-0 left-1/2 -translate-x-1/2">
          {sections.map((_, i) => (
            <div
              key={i}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                activeSection === i ? 'bg-[#A47F2D] scale-150' : 'bg-white/30'
              }`}
              style={i > 0 ? { marginTop: '38px' } : {}}
            />
          ))}
        </div>
      </div>

      {sections.map(({ Component, zIndex }, i) => (
        <section
          key={zIndex}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            zIndex,
            backgroundColor: '#000',
            overflow: 'hidden',
            transition: i === 0 ? 'none' : 'transform 1.4s cubic-bezier(0.77, 0, 0.175, 1)',
            transform: i === 0 ? 'translateY(0)' : activeSection >= i ? 'translateY(0)' : 'translateY(100%)',
          }}
        >
          {i === 3 ? (activeSection >= 2 ? <Component /> : null) : <Component />}
        </section>
      ))}
    </div>
  );
};

export default LandingPage;